import {PADDING, WIDTH, HEIGHT} from './constants.js';

export const getParametersFromSelection = (selection, effect, filteredParameters, macroToShow) => {
    let selected = [];
    let {x1,x2,y1,y2} = selection;
    let _x1 = Math.min(x1,x2);
    let _y1 = Math.min(y1,y2);
    let parameters = filteredParameters || effect._parameters;
    for (let p of parameters) {
        if (p.planeMacro && p.planeMacro !== macroToShow) {
            continue;
        }
        let {x,y} = p.getCoordinates(WIDTH, HEIGHT, PADDING);
        if (x >= x1 && x <= x2 && y >= y1 && y <= y2) {
            selected.push(p);
        }
    }
    return selected;
};
